import { YoutubeSetting } from "../interface/youtubeSetting";
import { GetYoutubeBindResponse } from "../interface/api/get-youtube-bind";
import { GetYoutubeLoginResponse } from "../interface/api/get-youtube-login";
import {
  PostYoutubeBindResponse,
  YoutubeSettingPayload,
} from "../interface/api/post-youtube-bind";

function mapPayloadToYoutubeSetting(
  payload: YoutubeSettingPayload | Record<string, unknown> | null | undefined
): YoutubeSetting | null {
  if (!payload || typeof payload !== "object") return null;

  const data = payload as YoutubeSettingPayload;
  if (!data.id && !data.channelId && !data.name) {
    return null;
  }

  return {
    id: data.id ?? data.channelId ?? "",
    name: data.name ?? "",
    channelName: data.channelName,
    email: data.email,
    avatarUrl: data.avatarUrl,
    expiresIn: data.expiresIn,
  };
}

export function mapYoutubeSettingPayload(
  payload: YoutubeSettingPayload | Record<string, unknown> | null | undefined
): YoutubeSetting | null {
  return mapPayloadToYoutubeSetting(payload);
}

export const youtubeSettingMapper = {
  mapResponseToYoutubeSetting(
    response: GetYoutubeBindResponse | PostYoutubeBindResponse
  ): YoutubeSetting | null {
    return mapPayloadToYoutubeSetting(response?.payload?.youtubeSetting);
  },

  mapResponseToYoutubeLoginUrl(response: GetYoutubeLoginResponse): {
    url: string;
  } {
    const { url } = response?.payload ?? {};
    return { url };
  },
};
